import React from "react";

import { getAllGimsUserPositions } from "../../../../redux/actions";

import { POSITIONS_COLUMNS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

import GeneralSectionComponent from "../generalSectionComponent";
import { getPosition } from "../../../../redux/directoryMaintenance/positionsReducer/actionPositions";
import PositionsModal from "./positionsModal/positionsModal";

import styles from "./positions.module.css";

const Positions = () => {
  return (
    <GeneralSectionComponent
      title="Должности"
      dataFromStateSelector={(state) => state.dictionaryReducer.allGimsUserPositions}
      getActionAll={getAllGimsUserPositions}
      getAction={getPosition}
      headerColumns={POSITIONS_COLUMNS}
      ModalComponent={PositionsModal}
      externalStyles={styles}
    />
  );
};

export default Positions;
